import React from "react";
import PropTypes from "prop-types";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import WarningBanner from "Components/warningBanner/WarningBanner";
import Button from "Components/button/Button";
import { withRouter } from "react-router-dom";
import qs from "query-string";
import cx from "classnames";
import s from "./firstViewDelegates.scss";

const ContextTypes = {
  router: PropTypes.object,
};

class FirstView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { hasArchive } = this.props;

    return (
      <div className={s.firstDelegates}>
        <div className={cx("sectionTitle", s.titleFD)}>{t("delegates.firstView.title")}</div>
        <div className={s.descFD}>
          <TranslatedString>delegates.firstView.desc</TranslatedString>
        </div>

        {!hasArchive && (
          <div className={s.infoFD}>
            <WarningBanner msg={<TranslatedString>delegates.firstView.warningMsg</TranslatedString>} />
          </div>
        )}
        <div className={s.btnCreate}>
          <Button color="green" onClick={() => this.props.history.push("/delegates/new")} disabled={!hasArchive}>
            button.createDelegate
          </Button>
        </div>
      </div>
    );
  }
}

FirstView.contextTypes = ContextTypes;

export default withRouter(FirstView);
